import type { ReactNode } from "react";

import React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

interface IconWrapperProps {
  children: ReactNode;
  className?: string;
  size?: "sm" | "base" | "lg";
}

const sizeMap = {
  sm: "w-7 h-7 p-1",
  base: "w-8 h-8 p-1",
  lg: "w-10 h-10 p-1.25",
};

export const IconWrapper = ({
  children,
  className,
  size = "base",
}: IconWrapperProps) => {
  return (
    <div
      className={twMerge(
        "rounded-lg flex items-center justify-center",
        "bg-black border border-border/20",
        "backdrop-blur-sm",
        sizeMap[size],
        className,
      )}
      style={{
        filter: "url(#icon-noise-filter)",
      }}
    >
      {children}
      <svg width="0" height="0" className="absolute">
        <defs>
          <filter
            id="icon-noise-filter"
            x="0%"
            y="0%"
            width="100%"
            height="100%"
          >
            <feTurbulence
              type="fractalNoise"
              baseFrequency="58.59375 58.59375"
              stitchTiles="stitch"
              numOctaves="3"
              result="noise"
              seed="226"
            />
            <feColorMatrix
              in="noise"
              type="luminanceToAlpha"
              result="alphaNoise"
            />
            <feComponentTransfer in="alphaNoise" result="coloredNoise1">
              <feFuncA
                type="discrete"
                tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
              />
            </feComponentTransfer>
            <feComposite
              operator="in"
              in2="SourceGraphic"
              in="coloredNoise1"
              result="noise1Clipped"
            />
            <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
            <feComposite
              operator="in"
              in2="noise1Clipped"
              in="color1Flood"
              result="color1"
            />
            <feMerge result="effect1_noise">
              <feMergeNode in="SourceGraphic" />
              <feMergeNode in="color1" />
            </feMerge>
          </filter>
        </defs>
      </svg>
    </div>
  );
};
